import { styled } from '@mui/material';
import { Edit } from 'react-admin';

import { detailContainerStyles } from '../styles';

export const EditContainer = styled(Edit)(detailContainerStyles);
